import {
  getRequiredValidationObj,
  getLengthValidationObj,
  getEmailValidationObj,
  getPhoneNumberValidationObj,
} from './form-validations';

import { getFormSusbmissionErrorObj } from './form-errors';

import {
  getTextFormFieldObj,
  getEmailFormFieldObj,
  getDropdownFormFieldObj,
  getCheckboxFormFieldObj,
} from './pardotFormConfig-utils';

const jobTitleOptions = [
  { value: 'Board Member', label: 'Board Member' },
  { value: 'Founder/Owner', label: 'Founder/Owner' },
  { value: 'C-suite/Director/VP', label: 'C-suite/Director/VP' },
  { value: 'Head of Department', label: 'Head of Department' },
  { value: 'Senior Manager/Manager', label: 'Senior Manager/Manager' },
  {
    value: 'Coordinator/Assistant/Secretary',
    label: 'Coordinator/Assistant/Secretary',
  },
];

const annualOnlineSaleOptions = [
  { value: 'More than 10M USD', label: 'More than 10M USD' },
  { value: '8 – 10 M USD', label: '8 – 10 M USD' },
  { value: '5 – 8 M USD', label: '5 – 8 M USD' },
];
const jobTitleOptionsc2 = [
  { value: '董事会成员', label: '董事会成员' },
  { value: '创始人/总裁', label: '创始人/总裁' },
  { value: 'C-suite/副总裁/总监', label: 'C-suite/副总裁/总监' },
  { value: '部门主管', label: '部门主管' },
  { value: '高级经理', label: '高级经理' },
  { value: '经理', label: '经理' },
  { value: '其他', label: '其他' },
];
const annualOnlineSaleOptionsc2 = [
  { value: '400000美元/月以上', label: '400000美元/月以上' },
  { value: '400000至200000美元/月之间', label: '400000至200000美元/月之间' },
  { value: '15000至200000/月之间', label: '15000至200000/月之间' },
  { value: '15000美元以下', label: '15000美元以下' },
];
const jobTitleOptionsJp = [
  { value: '会社経営者/オーナー', label: '会社経営者/オーナー' },
  { value: '会社役員', label: '会社役員' },
  { value: 'シニアマネージャー', label: 'シニアマネージャー' },
  { value: 'マネージャー', label: 'マネージャー' },
  { value: 'アシスタントマネージャー', label: 'アシスタントマネージャー' },
  { value: 'アシスタント/秘書/', label: 'アシスタント/秘書/' },
  { value: 'その他', label: 'その他' },
];
const annualOnlineSaleOptionsJp = [
  { value: '10億円以上', label: '10億円以上' },
  { value: '4億5000万円～10億円未満', label: '4億5000万円～10億円未満' },
  { value: '4億5000万円未満', label: '4億5000万円未満' },
];
const formHandlersArr = [
  {
    country: 'sg',
    articleId: 'enterprise-modern-payment-solutions-to-grow-your-business',
    formName: 'APAC-SG-FRH-23-ABM-Phase1-Key-Considerations-Live',
    actionUrl: '2023-04-26/2rxvr',
    redirectUrl: '/thank-you',
    submitButtonText: 'Submit',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'sg',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: 'First Name',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Last Name',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 80,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Company Name',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required.',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Company URL',
        htmlName: 'website',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: 'Business Email',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required.',
          }),
          getEmailValidationObj({
            country: 'sg',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Business Phone',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getPhoneNumberValidationObj({
            country: 'sg',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 40,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: 'Annual Online Sales Revenue',
        htmlName: 'annualonlinesales',
        required: true,
        span: 6,
        options: annualOnlineSaleOptions,
        placeholder: 'Please Select',
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          'I agree that I am above 18 years of age. I consent and agree to the <a href="https://www.paypal.com/sg/webapps/mpp/ua/privacy-full" target="_blank" data-pa-click="{&quot;link&quot;:&quot;pardot-form-text-link-0&quot;,&quot;event_name&quot;:&quot;ppcom_text_link_clicked&quot;}">PayPal Privacy Statement</a>. *',
        supportingText:
          'I consent to PayPal contacting me by phone or by email, and to sending me product, marketing communications or industry information relevant to my query.',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
    ],
  },
  {
    country: 'sg',
    articleId: 'enterprise-fraud-risk-assessment-management',
    formName: 'APAC-SG-FRH-23-Fraud-Risk-ABM+AOC-Live',
    actionUrl: '2023-04-27/2s1yv',
    redirectUrl: '/thank-you',
    submitButtonText: 'Submit',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'sg',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: 'First Name',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Last Name',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 80,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Company Name',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required.',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Company URL',
        htmlName: 'companywebsite',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: 'Business Email',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required.',
          }),
          getEmailValidationObj({
            country: 'sg',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Business Phone',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getPhoneNumberValidationObj({
            country: 'sg',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 40,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: 'Annual Online Sales Revenue',
        htmlName: 'annualonlinesales',
        required: true,
        span: 6,
        options: annualOnlineSaleOptions,
        placeholder: 'Please Select',
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          'I agree that I am above 18 years of age. I consent and agree to the <a href="https://www.paypal.com/sg/webapps/mpp/ua/privacy-full" target="_blank" data-pa-click="{&quot;link&quot;:&quot;pardot-form-text-link-0&quot;,&quot;event_name&quot;:&quot;ppcom_text_link_clicked&quot;}">PayPal Privacy Statement</a>. *',
        supportingText:
          'I consent to PayPal contacting me by phone or by email, and to sending me product, marketing communications or industry information relevant to my query.',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
    ],
  },
  {
    country: 'sg',
    articleId: 'enterprise-online-gaming-solutions',
    formName: 'APAC-SG-FRH-23-GLE-Gaming Campaign-Live-Live',
    actionUrl: '2023-04-21/2rwcy',
    redirectUrl: '/thank-you',
    submitButtonText: 'Submit',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'sg',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: 'First Name',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Last Name',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 80,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Company Name',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Company URL',
        htmlName: 'companywebsite',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: 'Business Email',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getEmailValidationObj({
            country: 'sg',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Business Phone',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getPhoneNumberValidationObj({
            country: 'sg',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 40,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: 'Job Title',
        htmlName: 'jobtitle',
        required: true,
        span: 6,
        options: jobTitleOptions,
        placeholder: 'Please Select',
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: 'Annual Online Sales Revenue',
        htmlName: 'annualonlinesales',
        required: true,
        span: 6,
        options: annualOnlineSaleOptions,
        placeholder: 'Please Select',
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          'I agree that I am above 18 years of age. I consent and agree to the <a href="https://www.paypal.com/sg/webapps/mpp/ua/privacy-full" target="_blank" data-pa-click="{&quot;link&quot;:&quot;pardot-form-text-link-0&quot;,&quot;event_name&quot;:&quot;ppcom_text_link_clicked&quot;}">PayPal Privacy Statement</a>. *',
        supportingText:
          'I consent to PayPal contacting me by phone or by email, and to sending me product, marketing communications or industry information relevant to my query.',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
    ],
  },
  {
    country: 'sg',
    articleId: 'enterprise-payment-fraud-types-detection-prevention',
    formName: 'APAC-SG-FRH-23-ABM-Phase-2-Fraud-Risk-LIVE',
    actionUrl: '2023-04-25/2rxp8',
    redirectUrl: '/thank-you',
    submitButtonText: 'Submit',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'sg',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: 'First Name',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Last Name',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 80,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Company Name',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required.',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Company URL',
        htmlName: 'companywebsite',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: 'Business Email',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required.',
          }),
          getEmailValidationObj({
            country: 'sg',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'Business Phone',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
          getPhoneNumberValidationObj({
            country: 'sg',
          }),
          getLengthValidationObj({
            country: 'sg',
            value: 40,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: 'Job Title',
        htmlName: 'jobtitle',
        required: true,
        span: 6,
        options: jobTitleOptions,
        placeholder: 'Please Select',
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: 'Annual Online Sales Revenue',
        htmlName: 'annualonlinesales',
        required: true,
        span: 6,
        options: annualOnlineSaleOptions,
        placeholder: 'Please Select',
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          'I agree that I am above 18 years of age. I consent and agree to the <a href="https://www.paypal.com/sg/webapps/mpp/ua/privacy-full" target="_blank" data-pa-click="{&quot;link&quot;:&quot;pardot-form-text-link-0&quot;,&quot;event_name&quot;:&quot;ppcom_text_link_clicked&quot;}">PayPal Privacy Statement</a>. *',
        supportingText:
          'I consent to PayPal contacting me by phone or by email, and to sending me product, marketing communications or industry information relevant to my query.',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'sg',
            errorMessage: 'This field is required',
          }),
        ],
      }),
    ],
  },
  {
    country: 'c2',
    articleId: 'enterprise-build-your-payment-mix',
    formName: 'APAC-CN-FRH-23-ABM-Phase2-Payment-Mix_LIVE',
    actionUrl: '2023-04-25/2rxnr',
    redirectUrl: '/thank-you',
    submitButtonText: '提交',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'c2',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: '名 *',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的名字',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '姓 *',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的姓氏',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 80,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: '邮件地址 *',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的邮件地址',
          }),
          getEmailValidationObj({
            country: 'c2',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '公司名称 *',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的公司名称',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '电话号码 *',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的电话号码',
          }),
          getPhoneNumberValidationObj({
            country: 'c2',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '公司网址',
        htmlName: 'companywebsite',
        required: false,
        span: 6,
        maxLength: 255,
        validations: [
          getLengthValidationObj({
            country: 'c2',
            value: 255,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '职位 *',
        htmlName: 'jobtitle',
        required: true,
        span: 6,
        options: jobTitleOptionsc2,
        placeholder: '请选择',
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请选择您的职位',
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '月销售额',
        htmlName: 'annualonlinesales',
        required: false,
        span: 6,
        options: annualOnlineSaleOptionsc2,
        placeholder: '请选择',
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          '本人确认已满18周岁。 本人同意并接受PayPal隐私声明。  本人同意PayPal以电话、电邮联系我，也同意接收与我所咨询服务相关的产品、宣传资料或业内资讯。',
        supportingText:
          '',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请勾选复选框',
          }),
        ],
      }),

    ],
  },
  {
    country: 'c2',
    articleId: 'enterprise-modern-payment-solutions-to-grow-your-business',
    formName: 'APAC-CN-FRH-23-ABM-Phase1-Key-Considerations-Live',
    actionUrl: '2023-05-04/2s582',
    redirectUrl: '/thank-you',
    submitButtonText: '提交',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'c2',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: '名 *',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的名字',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '姓 *',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的姓氏',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 80,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: '邮件地址 *',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的邮件地址',
          }),
          getEmailValidationObj({
            country: 'c2',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '公司名称 *',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的公司名称',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '电话号码 *',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的电话号码',
          }),
          getPhoneNumberValidationObj({
            country: 'c2',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '公司网址',
        htmlName: 'companywebsite',
        required: false,
        span: 6,
        maxLength: 255,
        validations: [
          getLengthValidationObj({
            country: 'c2',
            value: 255,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '职位 *',
        htmlName: 'jobtitle',
        required: true,
        span: 6,
        options: jobTitleOptionsc2,
        placeholder: '请选择',
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请选择您的职位',
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '月销售额',
        htmlName: 'annualonlinesales',
        required: false,
        span: 6,
        options: annualOnlineSaleOptionsc2,
        placeholder: '请选择',
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          '本人确认已满18周岁。 本人同意并接受PayPal隐私声明。  本人同意PayPal以电话、电邮联系我，也同意接收与我所咨询服务相关的产品、宣传资料或业内资讯。',
        supportingText:
          '',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请勾选复选框',
          }),
        ],
      }),

    ],
  },
  {
    country: 'c2',
    articleId: 'enterprise-payment-fraud-types-detection-prevention',
    formName: 'APAC-CN-FRM-22-ENT-Phase2-Fraud-Risk-ABM+AOC-Live',
    actionUrl: '2023-04-13/2rrq1',
    redirectUrl: '/thank-you',
    submitButtonText: '提交',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'c2',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: '名 *',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的名字',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '姓 *',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的姓氏',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 80,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: '邮件地址 *',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的邮件地址',
          }),
          getEmailValidationObj({
            country: 'c2',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '公司名称 *',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的公司名称',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '电话号码 *',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请输入您的电话号码',
          }),
          getPhoneNumberValidationObj({
            country: 'c2',
          }),
          getLengthValidationObj({
            country: 'c2',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '公司网址',
        htmlName: 'companywebsite',
        required: false,
        span: 6,
        maxLength: 255,
        validations: [
          getLengthValidationObj({
            country: 'c2',
            value: 255,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '职位 *',
        htmlName: 'jobtitle',
        required: true,
        span: 6,
        options: jobTitleOptionsc2,
        placeholder: '请选择',
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请选择您的职位',
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '月销售额',
        htmlName: 'annualonlinesales',
        required: false,
        span: 6,
        options: annualOnlineSaleOptionsc2,
        placeholder: '请选择',
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          '本人确认已满18周岁。 本人同意并接受PayPal隐私声明。  本人同意PayPal以电话、电邮联系我，也同意接收与我所咨询服务相关的产品、宣传资料或业内资讯。',
        supportingText:
          '',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'c2',
            errorMessage: '请勾选复选框',
          }),
        ],
      }),

    ],
  },
  {
    country: 'jp',
    articleId: 'enterprise-build-your-payment-mix',
    formName: 'APAC-JP-FRH-23-ABM-Phase2-Payment-mix-Live',
    actionUrl: '2023-04-19/2rtqt',
    redirectUrl: '/thank-you',
    submitButtonText: '無料で資料をダウンロードする',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'jp',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: '姓',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく姓を入力してください',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 80,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '名',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく名を入力してください',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '貴社名',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく貴社名を入力してください',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '貴社のウェブサイト',
        htmlName: 'companywebsite',
        required: false,
        span: 6,
        maxLength: 255,
        validations: [
          getLengthValidationObj({
            country: 'jp',
            value: 255,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: 'メールアドレス',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しくメールアドレス入力してください',
          }),
          getEmailValidationObj({
            country: 'jp',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'ビジネス用の電話番号',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しくビジネス用の電話番号を入力してください',
          }),
          getPhoneNumberValidationObj({
            country: 'jp',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 40,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '役職名',
        htmlName: 'jobtitle',
        required: true,
        span: 6,
        options: jobTitleOptionsJp,
        placeholder: '役職名をお選びください',
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく役職名を入力してください',
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '年間売上高',
        htmlName: 'annualonlinesales',
        required: true,
        span: 6,
        options: annualOnlineSaleOptionsJp,
        placeholder: '年間オンライン売上高(予測)をお選びください',
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: 'オプションを選択してください',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          '18歳以上の方のみ資料をご請求ください。このページに入力した情報は、<a href="https://www.paypal.com/jp/webapps/mpp/ua/privacy-full" target="_blank" data-pa-click="{&quot;link&quot;:&quot;pardot-form-text-link-0&quot;,&quot;event_name&quot;:&quot;ppcom_text_link_clicked&quot;}">PayPalのプライバシーポリシー</a>に従って使用されます。PayPalは、電話または電子メールでお客様に連絡する場合があります。また、この問い合わせに関連する製品、プロモーション、業界情報などを提供する場合があります。',
        supportingText:
          '',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: 'ご同意いただける場合はチェックを入れてください',
          }),
        ],
      }),

    ],
  },
  {
    country: 'jp',
    articleId: 'enterprise-payment-fraud-types-detection-prevention',
    formName: 'APAC-JP-FRH-23-ABM-Phase-2-Fraud Risk-Live-Live',
    actionUrl: '2023-04-21/2rwd5',
    redirectUrl: '/thank-you',
    submitButtonText: '無料で資料をダウンロードする',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'jp',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: '姓',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく姓を入力してください',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 80,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '名',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく名を入力してください',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '貴社名',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく貴社名を入力してください',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '貴社のウェブサイト',
        htmlName: 'companywebsite',
        required: false,
        span: 6,
        maxLength: 255,
        validations: [
          getLengthValidationObj({
            country: 'jp',
            value: 255,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: 'メールアドレス',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しくメールアドレス入力してください',
          }),
          getEmailValidationObj({
            country: 'jp',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'ビジネス用の電話番号',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しくビジネス用の電話番号を入力してください',
          }),
          getPhoneNumberValidationObj({
            country: 'jp',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 40,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '役職名',
        htmlName: 'jobtitle',
        required: true,
        span: 6,
        options: jobTitleOptionsJp,
        placeholder: '役職名をお選びください',
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく役職名を入力してください',
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '年間売上高',
        htmlName: 'annualonlinesales',
        required: true,
        span: 6,
        options: annualOnlineSaleOptionsJp,
        placeholder: '年間オンライン売上高(予測)をお選びください',
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: 'オプションを選択してください',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          '18歳以上の方のみ資料をご請求ください。このページに入力した情報は、<a href="https://www.paypal.com/jp/webapps/mpp/ua/privacy-full" target="_blank" data-pa-click="{&quot;link&quot;:&quot;pardot-form-text-link-0&quot;,&quot;event_name&quot;:&quot;ppcom_text_link_clicked&quot;}">PayPalのプライバシーポリシー</a>に従って使用されます。PayPalは、電話または電子メールでお客様に連絡する場合があります。また、この問い合わせに関連する製品、プロモーション、業界情報などを提供する場合があります。',
        supportingText:
          '',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: 'ご同意いただける場合はチェックを入れてください',
          }),
        ],
      }),

    ],
  },
  {
    country: 'jp',
    articleId: 'enterprise-modern-payment-solutions-to-grow-your-business',
    formName: 'APAC-JP-FRH-23-ABM-Phase1-Key-Considerations-Live',
    actionUrl: '2023-04-26/2rxvv',
    redirectUrl: '/thank-you',
    submitButtonText: '無料で資料をダウンロードする',
    formSubmissionCrticalErrorMessage: getFormSusbmissionErrorObj({
      country: 'jp',
    }),
    pdfLink: '',
    formFields: [
      getTextFormFieldObj({
        label: '名',
        htmlName: 'firstname',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく名を入力してください',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 40,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '姓',
        htmlName: 'lastname',
        required: true,
        span: 6,
        maxLength: 80,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく姓を入力してください',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 80,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '貴社名',
        htmlName: 'companyname',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく貴社名を入力してください',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: '貴社のウェブサイト',
        htmlName: 'companywebsite',
        required: false,
        span: 6,
        maxLength: 255,
        validations: [
          getLengthValidationObj({
            country: 'jp',
            value: 255,
          }),
        ],
      }),
      getEmailFormFieldObj({
        label: 'メールアドレス',
        htmlName: 'workemail',
        required: true,
        span: 6,
        maxLength: 255,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しくメールアドレス入力してください',
          }),
          getEmailValidationObj({
            country: 'jp',
            inputType: 'email',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 255,
          }),
        ],
      }),
      getTextFormFieldObj({
        label: 'ビジネス用の電話番号',
        htmlName: 'phonenumber',
        required: true,
        span: 6,
        maxLength: 40,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しくビジネス用の電話番号を入力してください',
          }),
          getPhoneNumberValidationObj({
            country: 'jp',
          }),
          getLengthValidationObj({
            country: 'jp',
            value: 40,
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '役職名',
        htmlName: 'jobtitle',
        required: true,
        span: 6,
        options: jobTitleOptionsJp,
        placeholder: '役職名をお選びください',
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: '正しく役職名を入力してください',
          }),
        ],
      }),
      getDropdownFormFieldObj({
        label: '年間売上高',
        htmlName: 'annualonlinesales',
        required: true,
        span: 6,
        options: annualOnlineSaleOptionsJp,
        placeholder: '年間オンライン売上高(予測)をお選びください',
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: 'オプションを選択してください',
          }),
        ],
      }),
      getCheckboxFormFieldObj({
        label:
          '18歳以上の方のみ資料をご請求ください。このページに入力した情報は、<a href="https://www.paypal.com/jp/webapps/mpp/ua/privacy-full" target="_blank" data-pa-click="{&quot;link&quot;:&quot;pardot-form-text-link-0&quot;,&quot;event_name&quot;:&quot;ppcom_text_link_clicked&quot;}">PayPalのプライバシーポリシー</a>に従って使用されます。PayPalは、電話または電子メールでお客様に連絡する場合があります。また、この問い合わせに関連する製品、プロモーション、業界情報などを提供する場合があります。',
        supportingText:
          '',
        htmlName: 'privacyconsent',
        required: true,
        span: 12,
        validations: [
          getRequiredValidationObj({
            country: 'jp',
            errorMessage: 'ご同意いただける場合はチェックを入れてください',
          }),
        ],
      }),

    ],
  },
];

export default formHandlersArr;
